export const ipToInt = (ip) => {
  if (typeof ip !== 'string') return null;
  const parts = ip.trim().split('.');
  if (parts.length !== 4) return null;
  return parts.reduce((acc, octet) => {
    const num = parseInt(octet, 10);
    if (isNaN(num) || num < 0 || num > 255) return null;
    return (acc << 8) + num;
  }, 0) >>> 0;
};

export const isIpAllowed = (userIp, allowedIpsConfig) => {
  if (!allowedIpsConfig || allowedIpsConfig.trim() === '' || allowedIpsConfig.trim() === '*') {
    return true;
  }
  const userIpInt = ipToInt(userIp);
  if (userIpInt === null) return false;

  const allowedList = allowedIpsConfig.split(',').map(item => item.trim()).filter(Boolean);

  for (const entry of allowedList) {
    if (entry === userIp) return true;

    if (entry.includes('/')) {
      const [net, bitsStr] = entry.split('/');
      const bits = parseInt(bitsStr, 10);
      const netInt = ipToInt(net);
      if (netInt !== null && !isNaN(bits) && bits >= 0 && bits <= 32) {
        const mask = bits === 0 ? 0 : (~0 << (32 - bits)) >>> 0;
        if ((userIpInt & mask) === (netInt & mask)) {
          return true;
        }
      }
    }
  }
  return false;
};

export const validateIpList = (ipListString) => {
  if (!ipListString || ipListString.trim() === '' || ipListString.trim() === '*') {
    return { isValid: true, invalidEntries: [] };
  }
  const entries = ipListString.split(',').map(item => item.trim()).filter(Boolean);
  const invalidEntries = [];

  for (const entry of entries) {
    if (entry.includes('/')) {
      const parts = entry.split('/');
      if (parts.length !== 2) {
        invalidEntries.push(entry);
        continue;
      }
      const [net, bitsStr] = parts;
      const bits = parseInt(bitsStr, 10);
      const netInt = ipToInt(net);
      if (netInt === null || isNaN(bits) || bits < 0 || bits > 32) {
        invalidEntries.push(entry);
      }
    } else {
      if (ipToInt(entry) === null) {
        invalidEntries.push(entry);
      }
    }
  }

  return {
    isValid: invalidEntries.length === 0,
    invalidEntries
  };
};
